const tabsData = [
  {
    id: 10,
    order: 1,
    title: "Short-term, long-term loans",
    offersInfo: "Active from May 2022",
    offers: [
      "Personal Loans: Whether it's for your personal needs or emergency, using the right credit for the right reasons can change your life. Get a tailored fixed interest rate from as low as 12.75%* per annum. ",
      "Home Loans: If you are concerned about how you are going to pay for your medical bill, we have got you covered with an Home Loan. Apply online through our convenient application process which pays out in minutes.",
      "Your repayment amount stays the same each month with up to 60 months to pay. No penalties if you settle your loan early.",
    ],
    titleBtn: "LOANS",
  },
  {
    id: 11,
    order: 2,
    title: "Cards selected for you",
    offersInfo: "Browse and see for yourself",
    offers: [
      "What makes a credit card attractive is the credit limit allowed to the cardholder. You can buy anything within that limit and pay later. Your monthly budget will not affect, even if you buy items of high value on credit.",
      "You can travel anywhere, without carrying much money if you have this card. Being the most accepted method of payment, you can use a credit card to pay anything.",
      "There are a few credit cards that allow you to withdraw money up to a certain limit in case of emergency, with no interest charged up to 45 to 50 days. You can make use of it in times of financial emergency.",
      "These cards come with reward points when you use them. For instance, IDFC FIRST Bank credit cards offer unlimited and never-expiring reward points, which are easily redeemable.",
    ],
    titleBtn: "CARDS",
  },
  {
    id: 12,
    order: 3,
    title: "Compare car insurances",
    offersInfo: "Car insurance",
    offers: ["Pays for the damage: If you have an accident and it's your fault, you’ll have to pay for your own car's repairs, as well as the other person's car. That's a lot of money!",
    "Replaces a stolen car: Picture the scene: you've just done your shopping and you head towards your parking spot only to find that it's empty. Unfortunately, we’re all familiar with that feeling of dread. At least with car insurance (provided you've selected the theft option), you can put some money towards a replacement car.",
    "Fire protection:Insurance can't stop a fire damaging your car or hail pelting down and causing damage but it can certainly help pay for repairs."],
    titleBtn: "INSURANCE"
  },
  
  {
    id: 13,
    order: 4,
    title: "Internet",
    offersInfo: "From Uncapped 20/10 Mbps",
    offers: ["Find out if there is an ADSL, Fibre or VDSL internet connection in your locality.",
    "Select unlimited package deals based on the speeds you want. There are different offers at different prices.",
    "Make an order through any of the approved ways. You can either call the customer service line, place the order online or visit any of the Telkom shops near you. Go for whichever option is convenient for you.",
    "All the above offers come with an installation and wireless router. Premium packages include unlimited calls to Telkom and different sizes of mobile data. The price is valid for the first 6 months on a 24-month contract. To qualify for the deals you should sign up before March 21, 2021."],
    titleBtn: "INTERNET"
  },
];

export default tabsData;
